// cross browsers addRule method
import { raf } from './raf.js';
export function removeCSSRule(sheet, index) {
  // return raf(function() {
    'deleteRule' in sheet ?
      sheet.deleteRule(index) :
      sheet.removeRule(index);
  // });
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/removeCSSRule.js
// module id = 855
// module chunks = 2